export default "__VITE_ASSET__B6Sy5Gby__"